<template>
  <!-- 头部导航栏 -->
  <HeaderNav v-if="!isShowNav"></HeaderNav>

  <!-- 面包屑 -->
  <breadcrumb v-if='route.name != "login" && route.name != "regin" &&
  route.name != "forgetPassword"  && route.name != "home" &&
  route.name != "service" && route.name != "customerServiceAppointmentPreview"
  && route.name != "appointment" && route.name != "appointmentPreview" &&
  route.name != "currentTime" && route.name != "conversionTime" &&
  route.name != "yellowPagesSearch" && route.name != "sso" && route.name != "approve"
  '></breadcrumb>

  <router-view></router-view>

  <!-- 底部导航 -->
  <FooterNav v-if="!isShowNav"></FooterNav>

  <!-- 返回顶部 -->
  <goTopBar v-if="!isShowNav"></goTopBar>


  <Transition name="fade">
    <MessageBox v-if="store.state.alertShowInfo.isShow"></MessageBox>
  </Transition>

  <!-- 联系我们悬浮 -->
  <support-code v-if='route.name != "conversionTime"'></support-code>

</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { isMobile } from './composables/browserInfo';
import HeaderNav from './components/headerNav/headerNav.vue';
import FooterNav from './components/footerNav/footerNav.vue';
import goTopBar from './components/goTopBar/goTopBar.vue';
import breadcrumb from './components/breadcrumb/breadcrumb.vue';
import MessageBox from './components/messageBox/messageBox';
import {useI18n} from "vue-i18n";
import axios from "axios";
import i18n from "@/main";
const { locale } = useI18n()
const route = useRoute();
const store = useStore();

const isShowNav = computed(() => {
  return route.name == "login" || route.name == "regin" || route.name == "forgetPassword"
      ||route.name == "service" ||route.name == "appointment"
      || route.name == "currentTime" || route.name == "conversionTime" || route.name == "yellowPagesSearch"
      || route.name == "sso" || route.name == "approve"
      ;
})

onMounted(() => {
  store.dispatch("asyncUpdateIsMobile", isMobile())
  createdLanguage()
})

function loadLanguageAsync(lang){
  axios.get(`/languages/${lang}.json`).then(response => {
    const messages = response.data;
    i18n.global.setLocaleMessage(lang,messages)
    locale.value = lang

    localStorage.setItem(
        'currentLang',
        JSON.stringify({
          currentLang: locale.value
        })
    )
  }).catch(err => {
    console.log(err)
  })
}

// 初始化多语言
function createdLanguage(){
  // 获取当前浏览器的语言  ja-JP(日本)
  // var lang = navigator.language;
  // console.log(lang)
  // if(lang === 'zh-CN'){
  //   locale.value = 'cn';
  // }
  // if(lang === 'en-US'){
  //   locale.value = 'en';
  // }
  // if(lang === 'ja-JP'){
  //   locale.value = 'ja';
  // }
  // 获取刷新之前的语言信息
  const sessionLang = JSON.parse(localStorage.getItem('currentLang'))
  console.log(sessionLang)
  if (sessionLang !== null) {
    // 获取到存储的路由列表之后，将信息利用vuex进行存储
    if (sessionLang.currentLang === 'cn') {
      // locale.value = 'cn';
      loadLanguageAsync("cn")
    }
    if (sessionLang.currentLang === 'en') {
      // locale.value = 'en';
      loadLanguageAsync("en")
    }
    if (sessionLang.currentLang === 'ja') {
      // locale.value = 'ja';
      loadLanguageAsync("ja")
    }
    if (sessionLang.currentLang === 'zh-TW') {
      // locale.value = 'zh_TW';
      loadLanguageAsync("zh-TW")
    }
  }else {
    // 默认语言
    // locale.value = 'en';
    // loadLanguageAsync("en")
    // language.value = "English"
    // 获取当前浏览器的语言  ja-JP(日本)
    // var lang = navigator.language;
    // console.log(lang)
    // if (lang === 'zh-CN') {
    //   // locale.value = 'cn';
    //   loadLanguageAsync("cn")
    // }
    // if (lang === 'en-US') {
    //   // locale.value = 'en';
    //   loadLanguageAsync("en")
    // }
    // if (lang === 'ja-JP') {
    //   // locale.value = 'ja';
    //   loadLanguageAsync("ja")
    // }
    // if (lang === 'zh_TW') {
    //   // locale.value = 'ja';
    //   loadLanguageAsync("zh-TW")
    // }
  }

}

</script>

<style>
@import url("../public/styles/reset.css");
@import url("../public/styles/common.css");

::v-deep .el-input__inner{
	font-size: 0.83333vw;
}

.select-wrap .el-input__inner{
	font-size: 0.83333vw;
}


::v-deep .el-pagination__jump{
	display: none;
}
::v-deep .el-pagination{
	padding-top: 1.04166vw;
}

::v-deep .el-pager li.is-active{
	color: #B41D22;
}

::v-deep .el-button--primary{
	background-color: #B41D22;
	border-color: #B41D22;
}

::v-deep .el-button:hover{
	color: #B41D22;
	border-color: #B41D22;
	background-color: #fff;
}

::v-deep .el-button:focus{
	color: #B41D22;
	border-color: #B41D22;
	background-color: #fff;
}

::v-deep .el-pagination__jump{
	display: none;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
	background-color: #B41D22;
	border-color: #B41D22;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner{
	background-color: #B41D22;
	border-color: #B41D22;
}

::v-deep .el-pager li:hover{
	color: #B41D22;
}

html,
body {
  /*overflow: hidden;*/
  background: #F5F5F7;
}

.fade-enter-active {
  transition: all 0.2s ease-out;
}

.fade-leave-active {
  transition: all 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

::v-deep .el-pagination{
	padding-top: 1.04166vw;
}

::v-deep .el-pager li.is-active{
	color: #B41D22;
}

::v-deep .el-button--primary{
	background-color: #B41D22;
	border-color: #B41D22;
}

::v-deep .el-button:hover{
	color: #B41D22;
	border-color: #B41D22;
	background-color: #fff;
}

::v-deep .el-button:focus{
	color: #B41D22;
	border-color: #B41D22;
	background-color: #fff;
}

</style>
